import _ from 'lodash';
import { BaseController } from '../../../../../../../common/base/controller';

import template from './atruviaUserDataModal.html';

class AtruviaUserDataModalController extends BaseController {
  constructor(
    $scope,
    controllerService,
    atruviaUserDataModalService,
    notificationService,
  ) {
    'ngInject';
    super({
      controllerService,
      atruviaUserDataModalService,
      notificationService,
    });
    this.$scope = $scope;
  }

  close() {
    this.atruviaUserDataModalService.closeModal();
  }

  searchUsers() {
    this.selectedEmail = null;
    this.isSubmitting = true;
    this.searchTriggered = false;
    this.atruviaUserDataModalService
      .fetchPersonendaten(this.userData.newIban.replace(/\s/g, ''))
      .then(
        (response) => {
          this.foundPersons = response.data;
          this.searchTriggered = true;
        },
        (error) => {
          this.notificationService.error(
            `atruviaUserDataModal.${error.data.error}`,
          );
        },
      )
      .finally(() => {
        this.isSubmitting = false;
      });
  }

  get personsFound() {
    return !_.isEmpty(this.foundPersons);
  }

  selectPrimaryPerson(person) {
    this.primaryPerson = person;
  }

  submit() {
    this.atruviaUserDataModalService
      .fetchAddresses(this.primaryPerson)
      .then((resp) => {
        const { data } = resp;

        this.primaryPerson = data;
        this.mailAddresses = data.mailAddresses;

        if (
          this.mailAddresses &&
          this.mailAddresses.length > 1 &&
          !this.selectedEmail
        ) {
          this.selectedEmail = this.mailAddresses[0];
          return;
        }

        if (this.mailAddresses && this.mailAddresses.length === 1) {
          this.selectedEmail = this.mailAddresses[0];
        }

        if (this.selectedEmail) {
          sessionStorage.setItem('emailAddressCustomer', this.selectedEmail);
        }

        let additionalAccountOwners = [];
        if (this.primaryPerson.mehrheitspersonBeteiligte) {
          additionalAccountOwners = _.filter(
            this.foundPersons,
            (p) => p.personennummer !== this.primaryPerson.personennummer,
          );
        }

        if (this.personsFound) {
          const primary = {
            ...this.primaryPerson,
            mailAddresses: [this.selectedEmail],
          };
          const hasMultipleAccountHolder =
            this.primaryPerson.mehrheitspersonBeteiligte;

          const stashPayload = hasMultipleAccountHolder
            ? [this.primaryPerson, ...additionalAccountOwners]
            : [this.primaryPerson];

          return this.atruviaUserDataModalService
            .stashUser(stashPayload)
            .then((resp) => {
              this.atruviaUserDataModalService.closeModal({
                ...this.userData,
                additionalAccountOwners,
                email: this.selectedEmail,
                stashedPersonNumber: resp.data.personnummer,
                primary,
                hasMultipleAccountHolder,
              });
            });
        }
      });
  }

  resetForm() {
    this.foundPersons = [];
    this.selectedEmail = '';
    this.searchTriggered = false;
    this.userData = { newIban: '', oldIban: '' };
    this.primaryPerson = null;

    this.$timeout(() => {
      this.form.$setPristine();
      this.form.$setUntouched();
    });
  }

  $onInit() {
    this.userData = { ...this.resolve.userData };
    this.foundPersons = [];

    this.ibanOptions = { validate: 'iban' };
    this.newIbanMessages = {
      required: 'app.form.error.message.required',
      iban: 'app.form.error.message.iban',
      type: 'receiving.createRequest.form.error.type.newIban',
    };
    this.oldIbanMessages = {
      required: 'app.form.error.message.required',
      iban: 'app.form.error.message.iban',
      type: 'receiving.createRequest.form.error.type.oldIban',
    };
    this.personMessages = {
      required: 'app.form.error.message.required',
    };

    this.$scope.$watchGroup(
      ['vm.userData.newIban', 'vm.userData.oldIban'],
      ([newIban, oldIban]) => {
        if (!this.form) return;
        const ibansEqual = !!newIban && !!oldIban && newIban === oldIban;
        if (this.form.newIban) {
          this.form.newIban.$setValidity('type', !ibansEqual);
        }
        if (this.form.oldIban) {
          this.form.oldIban.$setValidity('type', !ibansEqual);
        }
      },
    );
  }
}

export default {
  restrict: 'E',
  bindings: {
    resolve: '<',
  },
  template,
  controllerAs: 'vm',
  controller: AtruviaUserDataModalController,
};
